import "core-js/modules/es.object.assign.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { VoidUrl } from "@/common/types";
import { formatImageUrl } from "@/common/utils";
import { cmsHomeUrl } from "@/urls";
import { CompanyMembershipTypeEnum } from "@/apis/model/CompanyMembershipTypeEnum";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";

function ContactUserExtraCompanyInfo(props) {
  var company = props.company;
  var companyUrl = cmsHomeUrl(company.CompanyId, {
    stat_ctx: "ChatContact"
  });
  var verifiedIconUrl = formatImageUrl(company.CompanyVerifiedIco.AbsoluteUrl, ImageSizeTypeEnum.Thumbnail44whFill);
  var membershipIconUrl = formatImageUrl(company.CompanyPackageIco.AbsoluteUrl, ImageSizeTypeEnum.Thumbnail44whFill);
  return _jsx("div", __assign({
    className: "chat-contact-info__company"
  }, {
    children: company.NoShops ? _jsx("a", __assign({
      href: VoidUrl,
      className: "chat-contact-info__company-name js-no-shop",
      "data-companyid": company.CompanyId,
      target: "_blank"
    }, {
      children: company.CompanyName
    }), void 0) : _jsxs("div", __assign({
      className: "chat-contact-info__company-info"
    }, {
      children: [_jsx("a", __assign({
        href: companyUrl,
        className: "chat-contact-info__company-name",
        target: "_blank"
      }, {
        children: company.CompanyName
      }), void 0), company.IsCompanyVerified ? _jsx("img", {
        className: "chat-contact-info__verification-icon",
        src: verifiedIconUrl
      }, void 0) : undefined, company.CompanyPackageType !== CompanyMembershipTypeEnum.None ? _jsx("img", {
        className: "chat-contact-info__membership-icon",
        src: membershipIconUrl
      }, void 0) : undefined]
    }), void 0)
  }), void 0);
}

export default function ContactExtraUserInfo(props) {
  var _a = props.user.User,
      u = _a.User,
      c = _a.Company,
      r = props.company.Region;
  return _jsxs(React.Fragment, {
    children: [c && _jsx(ContactUserExtraCompanyInfo, {
      company: c
    }, void 0), _jsxs("ul", __assign({
      className: "chat-contact-info__info-items"
    }, {
      children: [_jsxs("li", __assign({
        className: "chat-contact-info__info-item"
      }, {
        children: [_jsx("span", __assign({
          className: "chat-contact-info__item-title"
        }, {
          children: "\u804C\xA0\xA0\xA0\u4F4D"
        }), void 0), _jsx("span", __assign({
          className: "chat-contact-info__item-value"
        }, {
          children: u.Profession
        }), void 0)]
      }), void 0), _jsxs("li", __assign({
        className: "chat-contact-info__info-item"
      }, {
        children: [_jsx("span", __assign({
          className: "chat-contact-info__item-title"
        }, {
          children: "\u7535\xA0\xA0\xA0\u8BDD"
        }), void 0), _jsx("span", __assign({
          className: "chat-contact-info__item-value"
        }, {
          children: u.Mobile
        }), void 0)]
      }), void 0), _jsxs("li", __assign({
        className: "chat-contact-info__info-item"
      }, {
        children: [_jsx("span", __assign({
          className: "chat-contact-info__item-title"
        }, {
          children: "\u5730\xA0\xA0\xA0\u5740"
        }), void 0), _jsx("span", __assign({
          className: "chat-contact-info__item-value"
        }, {
          children: r.FirstLevel + " " + r.SecondLevel
        }), void 0)]
      }), void 0)]
    }), void 0)]
  }, void 0);
}